import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => (
  {
    styledToast: {
      zIndex: '20000 !important',
    },
  }
))
